import hello from 'hellojs';
import History from 'LocalHistory';
// TODO: fix this cyclic dependency
// eslint-disable-next-line import/no-cycle
import API from 'API';

/**
 * Initializes the hellojs library with the AAD credentials.
 */
hello.init({
  aad: {
    id: process.env.REACT_APP_CLIENT_ID,
    oauth: {
      version: '2',
      auth: process.env.REACT_APP_AUTH_URL,
    },
    scope_delim: ' ',
    // Don’t even try submitting via form.
    // This means no POST operations in <=IE9
    form: false,
  },
});

/**
 * Returns the auth payload from local storage.
 */
const getAuthentication = () => JSON.parse(localStorage.authentication);
/**
 * Sets the auth payload in local storage.
 * @param {*} authentication The auth payload.
 */
const setAuthentication = (auth) =>
  localStorage.setItem('authentication', JSON.stringify(auth));
/**
 * Logs the user out by deleting the auth payload.
 */
const logout = () => {
  localStorage.removeItem('authentication');
  History.push('/login');
};
/**
 * Gets the realm of the payload in local storage.
 */
const getRealm = () => getAuthentication().realm;
/**
 * Calculates the time remaining for the token.
 */
const getTokenTimeRemaining = () => {
  const tokenExpiry = getAuthentication().aadToken.expires;
  const dateToCompare = Math.floor(Date.now() / 1000);

  return tokenExpiry - dateToCompare;
};
const refreshAADToken = async () => {
  try {
    const {
      authResponse: aadToken,
      authResponse: {id_token: token},
    } = await hello('aad').login({
      display: 'none',
      prompt: 'none',
      scope: 'openid,profile,email,user.read',
      redirect_uri: window.location.origin,
      response_type: 'id_token token',
      nonce: '12345',
    });
    // Manage token or tokens
    const authentication = {
      type: 'AAD',
      realm: 'Bearer',
      token,
      aadToken,
    };

    setAuthentication(authentication);

    return authentication;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
    logout();

    throw error;
  }
};
/**
 * Gets a token that is ready for use.
 */
const getToken = async () => {
  const authentication = getAuthentication();

  switch (authentication.type) {
    case 'Basic':
      return authentication.token;
    case 'AAD':
      if (getTokenTimeRemaining() < 0) {
        const {token} = await refreshAADToken();

        return token;
      }

      return authentication.token;
    default:
      throw new Error('Token Error');
  }
};
/**
 * Constructs an HTTP authentication header.
 */
const getHeader = async () => {
  const token = await getToken();

  return `${getRealm()} ${token}`;
};
/**
 * Makes sure that a users login is valid.
 * It is expected that a login function would use the promise returned.
 * Login method would await promise and redirect or perform a special function.
 */
const testAuthentication = async () => {
  const header = await getHeader();

  return fetch(`${API.BASE}users/me`, {
    method: 'get',
    mode: 'cors',
    headers: {
      'Content-type': 'application/json',
      Authorization: header,
    },
  });
};

class Authentication {
  /**
   * Checks the local storage for a payload to determine if
   * the user is logged in.
   */
  static isLoggedIn = () => !!localStorage.authentication;

  /**
   * Deletes the auth payload from local storage to log
   * the user out.
   */
  static logout = () => logout();

  /**
   * Same as above
   */
  static getHeader = () => getHeader();

  /**
   * Handles basic log in.
   * @param {string} username The username.
   * @param {string} password The password.
   */
  static basicLogin = async (username, password) => {
    const authentication = {
      type: 'Basic',
      realm: 'Basic',
      token: btoa(`${username}:${password}`),
    };

    setAuthentication(authentication);
    try {
      await testAuthentication();
      History.push('/');
    } catch (error) {
      // TODO: Use a better notification system
      alert('Incorrect Username/Password');
    }
  };

  /**
   * Handles logging in via Azure Active Directory.
   */
  static aadLogin = async () => {
    const {
      authResponse: aadToken,
      authResponse: {id_token: token},
    } = await hello('aad').login({
      display: 'popup',
      scope: 'openid,profile,email,user.read',
      redirect_uri: window.location.origin,
      response_type: 'id_token token',
      nonce: '12345',
    });
    // Manage token or tokens
    const authentication = {
      type: 'AAD',
      realm: 'Bearer',
      token,
      aadToken,
    };

    setAuthentication(authentication);
    try {
      await testAuthentication;
      History.push('/');
    } catch (error) {
      // TODO: Use a better notification system
      alert('ad token not valid');
    }
  };
}

export default Authentication;
